import { useEffect } from 'react';
import digitalMenu from '../assets/images/digital-menu.png';
import pdfMenu from '../assets/images/pdf-menu.png';
import Button from './Button';
import styled from 'styled-components';
import { Link } from "react-router-dom";
import { up } from "styled-breakpoints";
import FormContainer from "./FormContainer";
import { useUser } from '../api/queries';
import Loader from './Loader';
import { useCookies } from 'react-cookie';

const MenuSelectionWrap = styled.div`
    width: 100%;
    display: flex;
    margin: 0 auto;
    justify-content: space-between;
    flex-direction: column;

    ${up('sm')} {
        flex-direction: row;
    }
`;

const MenuSelectionImage = styled.img`
    height: 90%;
    width: auto;
    margin: 0 auto;
    display: block;
`;

const MenuSelectionItem = styled.div`
    width: 100%;
    height: 500px;

    a {
        text-decoration: none;
    }

    ${up('sm')} {
        width: 50%;
        height: 375px;
    }

    ${up('md')} {
        height: 400px;
    }

    ${up('lg')} {
        height: 425px;
    }

    ${up('xl')} {
        height: 450px;
    }

    ${up('xxl')} {
        height: 500px;
    }

    ${up('giant')} {
        height: 600px;
    }

`;

function MenuSelectionPage(props) {
    // Load user to check user is auth-ed
    const { data: user } = useUser();

    useEffect(() => {
        props.setHeader("Menu builder");
        props.setSubheader("How would you like customers to view your digital menu?")
        return () => {
            props.setHeader('')
            props.setSubheader('')
        }
    }, [props]);

    if (!user) {
      return <Loader/>
    }

    return (
      <FormContainer>
        <MenuSelectionWrap>
            <MenuSelectionItem>
                <MenuSelectionImage src={digitalMenu} />
                <Link to='/menu-builder/visual-menu/create-menu'>
                    <Button width='80%' text='Visual Menu' type="button" />
                </Link>
            </MenuSelectionItem>
            <MenuSelectionItem>
                <MenuSelectionImage src={pdfMenu} />
                <Link to='/menu-builder/pdf-menu'>
                    <Button width='80%' text='PDF Menu' type="button" />
                </Link>
            </MenuSelectionItem>
        </MenuSelectionWrap>
      </FormContainer>
    )
}

export default MenuSelectionPage;
